export const KEYBOARD = {
  ESC: 27
};
